import { Main } from './pages/main';
import './App.css';


function App() {
	return (
		<div className="App">
			<Main />
		</div>
	);
}

export default App;
